import { z } from 'zod';
import { ERROR_MESSAGES, STATES } from '~/constants';
import { optionSchema } from '../../../types';

const validStateCodes = STATES.map((state) => state.value);
export const CDS_LICENSE_TITLE_MAX = 32;

export const CdsLicenseFormSchema = z
  .object({
    id: z.number(),
    activeFlag: z.boolean(),
    licenseNum: z.string().min(5, { message: ERROR_MESSAGES.MIN_CHARACTER_LIMIT(5) }),
    expiryDate: z.iso.date(ERROR_MESSAGES.INVALID_DATE),
    issueDate: z.iso.date(ERROR_MESSAGES.INVALID_DATE),
    licenseTitle: z
      .string()
      .max(CDS_LICENSE_TITLE_MAX, ERROR_MESSAGES.MAX_CHARACTER_LIMIT(CDS_LICENSE_TITLE_MAX)),
    issuingAgency: z.string().min(1, ERROR_MESSAGES.REQUIRED),
    issuingStateCode: optionSchema.refine((option) => validStateCodes.includes(option.value), {
      message: 'Invalid state code selected',
    }),
    providerId: z.number().optional(),
    validFlag: z.boolean().optional(),
    warnings: z.record(z.string(), z.string()).optional(),
  })
  .refine(
    (data) => {
      if (!data.activeFlag) return true;
      const now = new Date();
      const todayISO = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`;
      return data.expiryDate > todayISO;
    },
    {
      message: 'License cannot be active if already expired',
      path: ['activeFlag'],
    }
  )
  .refine((data) => data.expiryDate > data.issueDate, {
    message: ERROR_MESSAGES.INVALID_DATE_ORDER('Issue Date', 'Expiration Date'),
    path: ['expiryDate'],
  });
export type CdsLicenseFormValues = z.infer<typeof CdsLicenseFormSchema>;
